// Single source of truth for the site's public origin.
// Used by the listicle page and the prerender/sitemap script.
export const SITE_URL = 'https://curateed.org';